import React, { useState } from "react";

interface AddEstimateHeaderModalProps {
	isOpen: boolean;
	onClose: () => void;
	onAdd: (header: string) => void;
	isUpdating: boolean;
}

const AddEstimateHeaderModal: React.FC<AddEstimateHeaderModalProps> = ({ isOpen, onClose, onAdd, isUpdating }) => {
	const [headerName, setHeaderName] = useState("");

	if (!isOpen) return null;

	const handleAdd = () => {
		const trimmed = headerName.trim();
		if (!trimmed) return;
		onAdd(trimmed);
		setHeaderName("");
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === "Enter") handleAdd();
		if (e.key === "Escape") onClose();
	};

	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
			<div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
				<h3 className="text-lg font-semibold text-gray-900 mb-4">Add Estimate Header</h3>
				<div className="mb-6">
					<label className="block text-sm font-medium text-gray-700 mb-1">Header name</label>
					<input
						type="text"
						value={headerName}
						onChange={(e) => setHeaderName(e.target.value)}
						onKeyDown={handleKeyDown}
						placeholder="e.g. Claim Number"
						className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
						autoFocus
					/>
				</div>
				<div className="flex justify-end gap-3">
					<button
						onClick={onClose}
						className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
						disabled={isUpdating}
					>
						Cancel
					</button>
					<button
						onClick={handleAdd}
						disabled={!headerName.trim() || isUpdating}
						className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
					>
						Add
					</button>
				</div>
			</div>
		</div>
	);
};

export default AddEstimateHeaderModal;
